export default __webpack_public_path__ + "36e7a8bfb3f250ddc37493130add89e5.woff";